import React from "react";
import { GoogleLogin } from '@react-oauth/google';
import useLoading from "../hooks/useLoading";
import useAuth from '../hooks/useAuth';
import useUser from '../hooks/useUser';
import Api from "../util/api";
import Util from "../util/util";
import swal from "sweetalert2";
import PropTypes from "prop-types";


export default function GoogleLoginButton({ source, onSuccess }) {
    const { startLoading, stopLoading } = useLoading();
    const { login } = useAuth();
    const { setStateApp, setUser } = useUser();

    const handleCredential = async (credential) => {
        try {
            startLoading();
            var res = await Api.auth.googleLogin({
                ...credential,
                source
            });
            var data = await res.json();
            if (await Util.requestSuccess(res)) {
                localStorage.setItem("JWT", data.token);

                login(data.token);
                const jsonUser = JSON.parse(
                    decodeURIComponent(escape(atob(data.token.split(".")[1])))
                );
                setUser(jsonUser);
                localStorage.setItem("user", JSON.stringify(jsonUser));
                setStateApp((prevState) => ({
                    ...prevState,
                    usuario: {
                        _id: jsonUser._id,
                        nombre: jsonUser.nombre,
                        foto_perfil: jsonUser.foto_perfil,
                        email: jsonUser.email,
                        llave_publica_lifechain: jsonUser.llave_publica_lifechain
                    },
                }));
                onSuccess(data);
                stopLoading();
            } else {
                await swal.fire("¡Ups!", "Error al iniciar sesión con google.", "error");
            }
        } catch (e) {
            console.log(e);
            await swal.fire("¡Ups!", "Error al iniciar sesión. Es posible que tengas problemas con tu conexión a internet.", "error");

            stopLoading();
        }
    };

    return <GoogleLogin onSuccess={handleCredential} onError={() => alert('Error con Google')} />;
}

GoogleLoginButton.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    source: PropTypes.string
};